import { PurchaseProduct } from 'modules/purchase/constants'

export const PRICE_DESCRIPTION_KEYS = {
  [PurchaseProduct.SEVEN_DAY]: 'purchase.subscription.weeklyDisclaimer',
  [PurchaseProduct.ONE_MONTH]: 'purchase.subscription.monthlyDisclaimer',
  [PurchaseProduct.THREE_MONTHS]: 'purchase.subscription.quarterlyDisclaimer',
}
